import bortalLogo from "@/assets/bortal-logo-final-black.png";

interface BortalLogoProps {
  className?: string;
  showWordmark?: boolean;
}

const BortalLogo = ({ className = "", showWordmark = true }: BortalLogoProps) => {
  return (
    <img
      src={bortalLogo}
      alt="Bortal logo"
      width={120}
      height={28}
      fetchPriority="high"
      decoding="async"
      className={`h-7 md:h-10 w-auto shrink-0 object-contain ${className}`}
    />
  );
};

export default BortalLogo;
